import {Alert, Spin} from "@ui";
import PropTypes from "prop-types";
import {useEffect, useState} from "react";

import {useTranslation} from "react-i18next";
import useGetUserWallet from "../../../hooks/wallet/useGetUserWallet";

const TransferAmount = ({setTransferAmount, setIsNextDisabled}) => {
  const {isLoading, balance} = useGetUserWallet();
  const [error, setError] = useState("");

  const {t} = useTranslation();

  const isMobile = window.innerWidth <= 768;
  const FontSize = "16px";

  // Disable Next button on mount
  useEffect(() => {
    setIsNextDisabled?.(true);
  }, [setIsNextDisabled]);

  const handleChange = e => {
    const value = e.target.value;
    // Only allow numbers and decimals
    const numberRegex = /^\d*\.?\d*$/;
    if (value.trim() === "") {
      setError("");
      setIsNextDisabled?.(true);
      return;
    }
    if (!numberRegex.test(value)) {
      setError(t("transferStepsAmountError"));
      setIsNextDisabled?.(true);
      return;
    }
    const amount = Number.parseFloat(value);
    if (!balance) {
      setError(t("transferStepsAmountError2"));
      setIsNextDisabled?.(true);
      return;
    }
    if (amount > balance.balance) {
      setError(t("transferStepsAmountError2"));
      setIsNextDisabled?.(true);
      return;
    }
    if (Number.isNaN(amount) || amount <= 0) {
      setError(t("transferStepsAmountError"));
      setIsNextDisabled?.(true);
      return;
    }
    // Update the state with the validated amount
    setTransferAmount(amount);
    setError("");
    setIsNextDisabled?.(false);
  };

  return (
    <div>
      <h4
        style={{
          fontWeight: 700,
          fontSize: isMobile ? FontSize : undefined,
          marginTop: 0,
        }}
      >
        {t("transferStepsTransferAmount")}
      </h4>
      {isLoading && <Spin size="large" />}
      {!isLoading && error && (
        <Alert
          message={<span style={{color: "var(--theme-text-on-primary)"}}>{error}</span>}
          type="error"
          showIcon
        />
      )}
      {!isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            marginTop: 32,
          }}
        >
          <div style={{position: "relative", width: 317, height: 49}}>
            <input
              type="text"
              inputMode="decimal"
              pattern="[0-9]*"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: 100,
                opacity: 1,
                borderWidth: 1,
                paddingTop: 14,
                paddingRight: 60,
                paddingBottom: 14,
                paddingLeft: 23,
                background: "var(--status-warning-surface)",
                border: "1px solid var(--theme-border-medium)",
                fontWeight: 500,
                fontSize: 18,
                fontFamily: "inherit",
                boxSizing: "border-box",
                outline: "none",
                color: "var(--theme-text-on-primary)",
              }}
              placeholder={t("transferStepsTransferAmountInput")}
              onChange={handleChange}
            />
            <span
              style={{
                position: "absolute",
                right: 23,
                top: "50%",
                transform: "translateY(-50%)",
                fontWeight: 500,
                fontSize: 18,
                color: "var(--text-primary)",
                pointerEvents: "none",
              }}
            >
              Bs
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

TransferAmount.propTypes = {
  setTransferAmount: PropTypes.func.isRequired,
  setIsNextDisabled: PropTypes.func,
};

export default TransferAmount;
